export const defaultOnboardingIndividualTranslations = {
  ALREADY_ASSOCIATED_USERS_TITLE: 'Already associated',
  ALREADY_ASSOCIATED_USERS_DESCRIPTION:
    'This organisation has already been fully onboarded. Please sign in to the existing account, or start again with a different organisation.',
  DUPLICATE_EMAIL_TITLE: 'Email Address Already Registered',
  DUPLICATE_EMAIL_DESCRIPTION:
    'The email address provided is already registered.  Please sign in using your password, or use a different mail to sign up again.',
  CREATING_ORG_FAILED_TITLE: 'Failed To Create Organisation',
  CREATING_ORG_FAILED_DESCRIPTION:
    'There was an error setting up the organisation. Please check the details carefully and try again.',
  EMAIL_INVALID_TITLE: 'Invalid Email Address',
  EMAIL_INVALID_DESCRIPTION: 'The email address entered is invalid. Please provide a valid email to proceed.',
  EMAIL_REQUIRED_TITLE: 'Email',
  EMAIL_REQUIRED_DESCRIPTION: 'Email should not be empty',
  EMAIL_VERIFIED_BOOLEAN_TITLE: 'Verified Failed',
  EMAIL_VERIFIED_BOOLEAN_DESCRIPTION: 'There was an issue verifying your email.  Please try again.',
  EXISTING_USER_TITLE: 'User Already Exists',
  EXISTING_USER_DESCRIPTION:
    'This user is already registered.  Please use a different user name if setting up a new user.',
  ONBOARD_FAILED_TITLE: 'Failed Onboarding',
  ONBOARD_FAILED_DESCRIPTION:
    'There has been an issue with your application.  Please contact our customer support team.',
  UNABLE_TO_ADD_USER_TITLE: 'Failed To Add User',
  UNABLE_TO_ADD_USER_DESCRIPTION:
    'There has been an issue with adding this user.  Please contact our customer support team.',
  ONBOARD_SUCCESS_TITLE: 'Onboarding Completed',
  ONBOARD_SUCCESS_DESCRIPTION: 'Registration completed successfully',

  FIRST_NAME_REQUIRED_TITLE: 'First name',
  FIRST_NAME_REQUIRED_DESCRIPTION: 'First name should not be empty',
  FIRST_NAME_IS_STRING_TITLE: 'First name',
  FIRST_NAME_IS_STRING_DESCRIPTION: 'First name must be string',

  MIDDLE_NAME_IS_STRING_TITLE: 'Middle name',
  MIDDLE_NAME_IS_STRING_DESCRIPTION: 'Middle name must be string',

  LAST_NAME_REQUIRED_TITLE: 'Last Name Required',
  LAST_NAME_REQUIRED_DESCRIPTION: 'Last name is required',
  LAST_NAME_IS_STRING_TITLE: 'Last Name Required',
  LAST_NAME_IS_STRING_DESCRIPTION: 'Last name is required',

  PASSWORD_REQUIRED_TITLE: 'Password Required',
  PASSWORD_REQUIRED_DESCRIPTION: 'Password is required.',
  PASSWORD_IS_STRING_TITLE: 'Password',
  PASSWORD_IS_STRING_DESCRIPTION: 'Password is required.',

  COUNTRY_REQUIRED_TITLE: 'Address Detail Required',
  COUNTRY_REQUIRED_DESCRIPTION: 'Country is required.',
  COUNTRY_IS_STRING_TITLE: 'Address Detail Required',
  COUNTRY_IS_STRING_DESCRIPTION: 'Country is required.',
  COUNTRY_IS_ISO31661ALPHA2_TITLE: 'Invalid Address Format',
  COUNTRY_IS_ISO31661ALPHA2_DESCRIPTION: 'Country must be a valid ISO31661 Alpha2 code',

  ADDRESS1_IS_STRING_TITLE: 'Address Detail Required',
  ADDRESS1_IS_STRING_DESCRIPTION: 'Address line one is required.',

  ADDRESS2_IS_STRING_TITLE: 'Address Detail Required',
  ADDRESS2_IS_STRING_DESCRIPTION: 'Address line two is required.',

  ADDRESS3_IS_STRING_TITLE: 'Address Detail Required',
  ADDRESS3_IS_STRING_DESCRIPTION: 'Address line three is required.',

  ADDRESS4_IS_STRING_TITLE: 'Address Detail Required',
  ADDRESS4_IS_STRING_DESCRIPTION: 'Address line four is required.',

  CITY_REQUIRED_TITLE: 'Address Detail Required',
  CITY_REQUIRED_DESCRIPTION: 'City/Town is required.',
  CITY_IS_STRING_TITLE: 'Address Detail Required',
  CITY_IS_STRING_DESCRIPTION: 'City/Town is required.',

  POSTAL_CODE_REQUIRED_TITLE: 'Invalid Postal Code',
  POSTAL_CODE_REQUIRED_DESCRIPTION: 'Please enter a valid postal code to proceed.',
  POSTAL_CODE_IS_STRING_TITLE: 'Invalid Postal Code',
  POSTAL_CODE_IS_STRING_DESCRIPTION: 'Please enter a valid postal code to proceed.',

  DOB_REQUIRED_TITLE: 'Date Of Birth Required',
  DOB_REQUIRED_DESCRIPTION: 'Date of birth is required.',
  DOB_IS_STRING_TITLE: 'Date Of Birth Required',
  DOB_IS_STRING_DESCRIPTION: 'Date of birth is required.',
  DOB_IS_DATE_STRING_TITLE: 'Invalid Date Format',
  DOB_IS_DATE_STRING_DESCRIPTION: 'Date of birth must be in the format YYYY-MM-DD.',

  USERNAME_IS_STRING_TITLE: 'Invalid User Name',
  USERNAME_IS_STRING_DESCRIPTION: 'Please enter a valid user name to continue.',

  PROPERTY_NAME_IS_STRING_TITLE: 'Invalid Property Name',
  PROPERTY_NAME_IS_STRING_DESCRIPTION: 'Please enter a valid property name to proceed.',

  PROPERTY_NUMBER_IS_STRING_TITLE: 'Invalid Property Number',
  PROPERTY_NUMBER_IS_STRING_DESCRIPTION: 'Please enter a valid property number to proceed.',

  ORGANISATION_ID_IS_STRING_TITLE: 'Organisation ID Required',
  ORGANISATION_ID_IS_STRING_DESCRIPTION: 'You must provide an organisation ID.',
  ORGANISATION_ID_IS_UUID_TITLE: 'Organisation ID Required',
  ORGANISATION_ID_IS_UUID_DESCRIPTION: 'You must provide an organisation ID.',

  PHONE_REQUIRED_TITLE: 'Invalid Phone Number',
  PHONE_REQUIRED_DESCRIPTION: 'Please enter a valid phone number to proceed.',
  PHONE_IS_VALID_TITLE: 'Invalid Phone Number',
  PHONE_IS_VALID_DESCRIPTION: 'Please enter a valid phone number to proceed.',
  PHONE_IS_STRING_TITLE: 'Invalid Phone Number',
  PHONE_IS_STRING_DESCRIPTION: 'Please enter a valid phone number to proceed.',
  PHONE_VERIFIED_BOOLEAN_TITLE: 'Verification Success',
  PHONE_VERIFIED_BOOLEAN_DESCRIPTION: 'Please enter a valid phone number to proceed.',

  PHONE_OTP_INVALID_TITLE: 'Invalid OTP',
  PHONE_OTP_INVALID_DESCRIPTION: 'Verification failed',

  INVALID_SOURCE_OF_FUNDS_TITLE: 'Invalid source of funds',
  INVALID_SOURCE_OF_FUNDS_DESCRIPTION: 'Source of funds must be a valid source of funds',

  INVALID_PURPOSE_OF_FUNDS_TITLE: 'Invalid purpose of funds',
  INVALID_PURPOSE_OF_FUNDS_DESCRIPTION: 'Purpose of funds must be a valid purpose of funds',
  WRONG_EMAIL_OTP_TITLE: 'Verification Failed',
  WRONG_EMAIL_OTP_DESCRIPTION: 'The OTP provided is incorrect. Please try again.',
  WRONG_PHONE_OTP_TITLE: 'Verification Failed',
  WRONG_PHONE_OTP_DESCRIPTION: 'The OTP provided is incorrect. Please try again.',
  COUNTY_IS_STRING_TITLE: 'County Required',
  COUNTY_IS_STRING_DESCRIPTION: 'County is required.',

  PRODUCT_UNAVAILABLE_TITLE: 'Product Unavailable',
  PRODUCT_UNAVAILABLE_DESCRIPTION:
    'The selected product is no longer available. Please select a different product.',

  COMPANY_NOT_FOUND_TITLE: 'Company Not Found',
  COMPANY_NOT_FOUND_DESCRIPTION:
    'No company was found with the provided company number. Please check the number and try again.',

  COMPANY_NOT_ACTIVE_TITLE: 'Company Not Active',
  COMPANY_NOT_ACTIVE_DESCRIPTION:
    'This company is not active on Companies House and cannot be used for onboarding. Please check the company number or use a different company.',
};
